import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import Swal, { SweetAlertIcon } from "sweetalert2";
import * as CryptoJS from 'crypto-js';
import Dexie from "dexie";
import { Oauth } from "./Oauth";
import { RangoCalificacionChecklist } from "../types/type";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class Utilerias {

  static openImgNewWindow(base64) {
    const base64ImageData = base64;
    const contentType = 'image/png';

    const byteCharacters = atob(base64ImageData.substr('data:image/png;base64,'.length));
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');
  }

  static resultRangeChecklist(rangosCalificacion: RangoCalificacionChecklist[], calificacion): RangoCalificacionChecklist {
    let result;
    for (let rango of rangosCalificacion) {
      if (calificacion >= rango.ValorMin && calificacion <= rango.ValorMax) {
        result = rango;
        break;
      }
    }
    return result;
  }

  static closeSesion(http) {
    this.httpRequest(http, 'GetCatalogoAppSettings')
      .then((res: any) => {
        let endpoint = res.login_Domain + res.login_LogOut;
        let site = res.login_UrlRedirect;
        Dexie.delete('EstacionesTVA')
          .then(() => {
            if (res.debug == "true") {
              window.location.href = site;
              localStorage.clear();
            } else {
              let id_Token = localStorage['acTkn_id'];
              localStorage.clear();
              Oauth.logout(site, endpoint, id_Token, res.login_State);
            }
          });
      });
  }
  static downloadFile(FileName, ArchivoBs64) {
    let blob = new Blob([Utilerias.convertirBase64toBlob(ArchivoBs64, 'application/octet-stream', null)], { type: 'application/octet-stream' });
    
    const nav = (window.navigator as any)
    if (nav.msSaveOrOpenBlob) {
      nav.msSaveBlob(blob, FileName);
    }
    else {
      let elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = FileName;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  }

  static convertirBase64toBlob(base64, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(base64);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  static alertClient(title: string, message: string , idType: 0 | 1 | 2) {
    let type: SweetAlertIcon = 'error';
    switch (idType) {
      case 0:
        type = 'error'
        break;
      case 1:
        type = 'warning'
        break;
      case 2:
        type = 'success'
        break;
    }
    Swal.fire({
      title: title,
      icon: type,
      html: message,
      buttonsStyling: false,
      confirmButtonText: 'Aceptar',
      customClass: {
        confirmButton: 'btn btn-primary mr-2',
      }      
    });
  }

  static alertConfirm(message: string, title = '', confirmButtonText = 'Si', cancelButtonText = 'No') {
    return Swal.fire({
      icon: 'info',
      title,
      html: message,
      showConfirmButton: true,
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText,
      cancelButtonText,
      allowEnterKey: false,
      allowEscapeKey: false,
      customClass: {
        confirmButton: 'btn btn-primary mr-2',
        cancelButton: 'btn btn-danger'
      }
    });
  }

  static showLoaderSwal(message: string = 'Cargando...') {
    Swal.fire({
      title: message,
      allowOutsideClick: false,
      showConfirmButton: false,
      allowEnterKey: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading(); //activa el loader interno de SweetAlert2
      }
    });
  }
  
  static hideLoaderSwal() {
    Swal.close(); // Cierra el modal
  }

  static replaceSaltoHTML(input: string) {
    return input.replace(/\n/g, '<br>');
  }

  static datetimeToDateFormat(input: string, withTime: boolean = false) {
    if (input != null) {
      let date = input.split(' ')[0];
      let time = input.split(' ')[1];
      let dateArray = date.split('-');
      let result = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
      if (withTime) {
        result += ' ' + time.substring(0, 8);
      }
      return result;
    }
  }

  static removeItem(collection, key, id) {
    return collection = collection.filter(x => x[key] != id);
  }

  static ClearFields(vFields: string) {
    let Afields = vFields.split('|');
    for (let c in Afields) {
      $(Afields[c]).val('');
      $(Afields[c]).html('');
    }
  }

  static showLoader(show = true) {
    // this.Loader(show);
  }

  static Loader(OnOff) {

    if (OnOff == false) {
      $('#div-loader').hide();
      $('#divDashabilitarPantallaClientSide').hide();
      $('#alc').hide();
      $('#loader').hide();
    }
    else {
      $('#div-loader').show();
      $('#divDashabilitarPantallaClientSide').show();
      $('#alc').show();
      $('#loader').show();
    }
  };


  static httpRequest(http: HttpClient, method: string, type: string = null, body: object = null) {
    if (!navigator.onLine) {
      Utilerias.alertClient(null, 'Favor de verificar su conexión a internet', 1);
      return
    }
    let promise: Promise<object>;
    let urlService = environment.urlService;
    let headers = new HttpHeaders();
    if (localStorage['jwt']) {
      headers = new HttpHeaders({
        'Authorization': localStorage['jwt']
      });
    }
    let params = new HttpParams();
    if (type == null) { type = 'get'; }
    if (type == 'get' && body != null) {
      for (const prop in body) {
        params = new HttpParams().set(prop, body[prop]);
      }
    }
    const httpOptions: any = {
      headers: headers,
      params: params,

    };
    httpOptions.observe = 'response';
    return new Promise<object>((resolve, reject) => {
      switch (type) {
        case 'get':
          promise = http.get<any>(urlService + method, httpOptions).toPromise();
          break;
        case 'post':
          promise = http.post<any>(urlService + method, body, httpOptions).toPromise();
          break;
      }
      Utilerias.showLoader();
      promise.then((response: any) => {
        let newToken = response.headers.get('Authorization');
        localStorage['jwt'] = newToken;
        let result: any = response.body;
        result = result.Result;
        if (result.Exito) {
          resolve(result.Data)
        } else {
          Utilerias.showLoader(false);
          Utilerias.alertClient('', result.Error, 1);
          reject(result.Error);
        }
      }).catch(result => {
        Utilerias.showLoader(false);
        if (result.status == 401) {
          this.closeSesion(http);
        }
        else {
          Utilerias.alertClient('', 'Error al enviar la peticion al servidor', 1);
        }
        reject(result);
      });
    });
  }

  static obtenerTOkendeURL(http: HttpClient, method: string, code: string): string {

    let respuesta: string;
    let urlService = environment.urlService;

    const myheader = new HttpHeaders().set('Content-Type', 'application/json')
    let promise: Promise<object>;

    http.get(urlService + method + '?code=' + code, { headers: myheader }).subscribe((resp: any) => {
      respuesta = resp.Result.access_token;
    })

    return respuesta;
  }

  static descrypAES(cadena: string) {

    var key = CryptoJS.enc.Utf8.parse('8080808080808080');
    var iv = CryptoJS.enc.Utf8.parse('8080808080808080');

    let decryptedString = CryptoJS.AES.decrypt(cadena, key, { iv: iv });
    return decryptedString.toString(CryptoJS.enc.Utf8);
  }
}

export class httpRequest {
  type: string;
  constructor(private http: HttpClient) {
    this.type = 'get';
  }
  invoke(method: string, object: Object) {
    return Utilerias.httpRequest(this.http, method, this.type, object);
  }
}
